import { Typography } from '@euler/app/components/typography';
import { WiredBackButton } from '@euler/app/tv/components/BackButton';
import {
  kGeneralHeaderHeight,
  kScreenContentPadding,
} from '@euler/app/tv/functions/constants';
import { usePresentationTheme } from '@euler/app/tv/theme';
import { HStack } from '@euler/components/layout/Stack';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { StyleProp, ViewStyle } from 'react-native';

export const GeneralNavHeader = memo(
  ({ title, style }: { title: string; style?: StyleProp<ViewStyle> }) => {
    const theme = usePresentationTheme();
    const { rpx } = useResponsiveContext();
    return (
      <HStack
        css={`
          height: ${rpx(kGeneralHeaderHeight)}px;
          padding-left: ${rpx(kScreenContentPadding)}px;
          padding-right: ${rpx(kScreenContentPadding)}px;
        `}
        style={style}
      >
        <HStack justifyContent="flex-start">
          <WiredBackButton color={theme.navbar.backButtonColor} />
          <Typography.Label
            bold
            size={rpx(32)}
            color={theme.navbar.titleTextColor}
            css={`
              margin-left: ${rpx(20)}px;
            `}
          >
            {title}
          </Typography.Label>
        </HStack>
      </HStack>
    );
  },
);
